import { Component, OnDestroy, OnInit, ViewChild, ElementRef,  Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Subject, Subscription, takeUntil, } from 'rxjs';
import { HhsgSharedApplicationsService, HhsgSharedClientAdminService, HhsgSharedCorporationService, HhsgSharedFormStateService, HhsgSharedStuderSupportContactService, HhsgSharedTabControlService, HhsgSharedUserService } from '../../../services';
import { HhsgSharedAdminTab, HhsgSharedUserProfile } from '../../../models';
import { HhsgSharedApplication } from '../../../models/application.model';
import { HhsgSharedCorporation } from '../../../models/corporation.model';
import { HhsgSharedClient } from '../../../models/client.model';
import { HhsgSharedHuronContract } from '../../../models/huron-contract.model';
import { HhsgSharedClientContact, HhsgSharedClientContactApplication, HhsgSharedClientContactEmail } from '../../../models/client-contact.model';
import { HhsgSharedClientAKA } from '../../../models/client-aka.model';
import { HhsgSharedStuderOrganizationService } from '../../../services/studer/organization.service';
import { Constants } from '../../../utilities/constants.util';
import { HhsgSharedClientApplication } from '../../../models/client-application.model';
import { HhsgSharedStuderSupportContact } from '../../../models/sgportal-data-api-models/support-contact.model';
import { RoleUtil } from '../../../utilities/role.util';
import { HhsgSharedAdminBaseComponent } from '../../common/base.component';
import { HhsgSharedTabInterface } from '../../common/tab-control/tab.interface';
import { HhsgSharedTimezone } from '../../../models/timezone.model';
import {Location} from '@angular/common'; 

@Component({
    selector: 'edit-client',
    templateUrl: 'edit-client.component.html',
    styleUrls: ['edit-client.component.scss']
})
export class HhsgSharedEditClientComponent extends HhsgSharedAdminBaseComponent implements OnInit, OnDestroy, HhsgSharedTabInterface {
  @ViewChild('clientForm', { static: true }) clientForm: NgForm;
  @ViewChild('nameInput', { static: true }) clientNameElement: ElementRef;
  @ViewChild('addNameInput', { static: true }) addclientNameElement: ElementRef;

  @ViewChild('addPhoneInput', { static: true }) addclientPhoneElement: ElementRef;

  @ViewChild('addRoleInput', { static: true }) addclientRoleElement: ElementRef;

  @ViewChild('addNotesInput', { static: true }) addclientNotesElement: ElementRef;

  @ViewChild('addEmailListInput', { static: true }) addEmailListElement: ElementRef;

  @Input() tab: HhsgSharedAdminTab;
  
    public applications: HhsgSharedApplication[] = [];
    public corporations: HhsgSharedCorporation[] = [];
    public timeZones: HhsgSharedTimezone[] = [];
    public isEditing = false;
    public user = new HhsgSharedUserProfile();
    public loadingCls: string;
    public formGroup: FormGroup;
    public name: FormControl;
    public isaHuronEmployee: boolean;
    public readonly AccountNumber = 'accountNumber';
    public readonly ContractName = 'contractName';
    public readonly ContractNumber = 'contractNumber';
    public readonly ContractNotes = 'contractNotes';
    public readonly ContactName = 'contactName';
    public readonly Phone = 'phone';
    public readonly RoleOrTitle = 'roleOrTitle';
    public readonly ContactNotes = 'contactNotes';
    public readonly ContactEmail0 = 'contactEmail0';


    constructor(
        private _activatedRoute: ActivatedRoute,
        private _applicationService: HhsgSharedApplicationsService,
        private _clientAdminService: HhsgSharedClientAdminService,
        private _corporationService: HhsgSharedCorporationService,
        private _formStateService: HhsgSharedFormStateService,
        private _organizationService: HhsgSharedStuderOrganizationService,
        private _tabControlService: HhsgSharedTabControlService,
        public _routerService: Router,
        private _supportContactService: HhsgSharedStuderSupportContactService,
        private _userService: HhsgSharedUserService,
        private formBuilder: FormBuilder,
        private location: Location) {
      super(_formStateService, _routerService);
      this.createForm();
    }
  
    private $newContactAppIds: Map<number, number> = new Map();

    _activeClient: HhsgSharedClient;
    updateSuccess: boolean;
    isNew: boolean;
    confirmSaving: boolean;
    isSaving: boolean;
    isSubmitted: boolean = false;
    activeClientApplications: HhsgSharedApplication[];
    newHuronContract: HhsgSharedHuronContract = new HhsgSharedHuronContract();
    newHuronContractError: boolean = false;
    newContact: HhsgSharedClientContact = new HhsgSharedClientContact();

    newAka: HhsgSharedClientAKA = new HhsgSharedClientAKA();
    newAkaError: boolean = false;
    imageSizeError: boolean = false;
    isLogoAttachmentSuccessful: boolean = false;
    logoToUpload: File = null;
    contactEditEmails: HhsgSharedClientContactEmail[];
    newContactValidName: boolean = true;
    newContactValidEmail: boolean = true;
    newContactErrorMessageShow: boolean = false;
    editContactErrorMessageShow: boolean = false;
    newContactValidPhone: boolean = true;
    editedContactValidPhone: boolean = true;
    editedContactValidName: boolean = true;
    editedContactValidEmail: boolean = true;
    organizationError: boolean;
    showContracts: boolean;
    errorMessages: string[] = [];

    private _formData: FormData;
    private _unsubscribe$ = new Subject<void>();
    private _formChangesSubscription: Subscription;
    private _clickedPurchasedApplications: number[] = new Array();
    private _clickedActivatedApplications: number[] = new Array();
    set activeClient(client: HhsgSharedClient) {
        if (client) {
            this._activeClient = this.cloneObject(client); // Create a copy so updates aren't passed back to the client list 
            this.isNew = !client.id || client.id === 0;
            this.isSubmitted = false;
            HhsgSharedClientAdminService.currentClient = client;
            HhsgSharedClientAdminService.returnUrl = this._routerService.url;
        }

        this.resetMessages();
        this._formData = new FormData();
        this._organizationService.setOrganizationLegend(this._activeClient);
        this._organizationService.isVMorLEMSelected = this.isVMorLEMSelected();
        this._clickedActivatedApplications = new Array();
        this._clickedPurchasedApplications = new Array();
        this._formStateService.reset();

      if (this.formGroup) {
        this.formGroup.markAsPristine();
        }
    }

    get activeClient(): HhsgSharedClient {
        return this._activeClient ? this._activeClient : new HhsgSharedClient();
    }

    get newContactAppIds(): number[] { return Array.from(this.$newContactAppIds.values()); }
    set newContactAppIds(value: number[]) { this.$newContactAppIds.clear(); value.forEach((id) => this.$newContactAppIds.set(id, id)); }

  createForm() {
    this.formGroup = this.formBuilder.group({
      name: ['', [Validators.required,Validators.maxLength(150)]],
      corporation: [this.activeClient.corporationName],
      status: ['false', [Validators.required]],
      accountNumber: ['', [Validators.required,Validators.maxLength(50)]],
      website: ['', [Validators.maxLength(100)]],      
      timeZoneId: ['',[Validators.required]],
      newaka: ['', [Validators.maxLength(150)]],
      contractName: ['', [Validators.maxLength(150)]],
      contractNumber: ['', [Validators.required, Validators.maxLength(50)]],
      contractNotes: [''],
      address1: [this.activeClient.address1, [Validators.maxLength(150)]],
      address2: [this.activeClient.address2, [Validators.maxLength(150)]],
      city: [this.activeClient.city, [Validators.maxLength(150)]],
      state: [this.activeClient.geoRegion, [Validators.maxLength(50)]],
      zip: [this.activeClient.postalCode, [Validators.maxLength(10)]],
      contactName: ['', [Validators.maxLength(150)]],
      phone: ['', [Validators.maxLength(50)]],
      roleOrTitle: ['', [Validators.maxLength(150)]],
      contactNotes: ['', [Validators.maxLength(1000)]],
      contactEmail0: ['', [Validators.maxLength(50)]],
      corporationId: [''],
      deleteClientLogo: [this.activeClient.removeExistingLogo],
      editAka: ['', [Validators.maxLength(150)]],
      editContractName: ['', [Validators.maxLength(150)]],
      editContractNumber: ['', [Validators.maxLength(50)]],
      editContractNotes: [''],
      editContactName: ['', [Validators.maxLength(100)]],
      editPhone: ['', [Validators.maxLength(50)]],
      editRoleOrTitle: ['', [Validators.maxLength(150)]],
      editContactNotes: ['', [Validators.maxLength(1000)]],
      applicationArray: this.formBuilder.array([])
    });
  }

  async ngOnInit(): Promise<void> {
        await this.initLoading();
        this._tabControlService
        .tabSelected$
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe(() => {
            if (this.checkFormIsDirty) {
                this.cancel();
            }
        });

    }

    private async initLoading() {
        this.setLoadingStatus(true);
        this.errorMessages = [];
        this.isLogoAttachmentSuccessful = false;
        this.newContactErrorMessageShow = false;
        this._formStateService.clearAKAEvent$.subscribe(() => {
            this.clearClientAKA();
        });

        this._userService.getUserProfile()
            .pipe(takeUntil(this._unsubscribe$))
            .subscribe((user: HhsgSharedUserProfile) => {
                this.user = user;
            });

       this.isaHuronEmployee = this.isHuronEmployee();
        await this.loadCorporations();
        await this.loadTimeZones();

        this._activatedRoute.params.subscribe(async (params) => {
            let { clientId } = params;
            let client: HhsgSharedClient;
            clientId = clientId && clientId!=-1?clientId : this.activeClient&& this.activeClient.id?this.activeClient.id:-1;

            if (clientId && clientId != -1) {
              this.isEditing = true;
              this.isNew = false;
              client = await this._clientAdminService.getClient(clientId);
              this._clientAdminService.announceActiveClient(client);
              if (client.clientHuronContractModels && client.clientHuronContractModels?.length > 0) {
                this.formGroup.controls[this.ContractNumber].setValidators([Validators.maxLength(50)]);
              }
              this.formGroup.reset({
                name: client.name.toString(),
                corporation: client.corporationName,
                accountNumber: client.accountNumber,                
                timeZoneId:client.timeZoneId,
                status:client.isActive,
                website: client.websiteUrl,
                newaka: this.newAka.aka,
                deleteClientLogo: client.removeExistingLogo,
                zip: client.postalCode,
                address1: client.address1,
                address2: client.address2,
                city: client.city,
                state: client.geoRegion
              });

              let timezoneControl = this.formGroup.controls['timeZoneId'];
              if(timezoneControl && client.timeZoneId && client.timeZoneId.length > 0) {
                timezoneControl.reset({ disabled: true, value: client.timeZoneId });
              }

              this.createApplicationFormCont(client);
              if (!this.isHuronEmployee()) {
                this.formGroup.disable();
              }
            }
            else {
              client = new HhsgSharedClient(); 
                if (this.user) {
                    let userCorporation = this.corporations.find(c => c.id == +this.user.corporationId);

                    if (userCorporation) {
                        client.corporationName = userCorporation.name;
                    }
              }
              client.isActive = false;
            }

          this.activeClient = client;
        });          

    this.applications = await this._clientAdminService.getAllActiveApplications();
    this.applications = this.applications.filter(app => app.name !== 'Huron Accelerators');
   
        this.initClientContactEmailArray();

        this.activeClientApplications = this.applications.filter(app => {
            return this.clientHasActiveApplication(app);
        });

        this.showContracts = this.isHuronEmployee();
        this._formData = new FormData();
        this._organizationService.setOrganizationLegend(this.activeClient);
        this._organizationService.currentUser = this.user;
        this._formStateService.isFormDirty = false;
        this._formChangesSubscription = this.formGroup.valueChanges.subscribe(val => {
            this._formStateService.isFormDirty = this.checkFormIsDirty();
        }); 
   
    
    if (!this.isaHuronEmployee) {
      this.formGroup.disable();
    }
    this.formGroup.get('contactEmail0').valueChanges.subscribe(val => {
      this.newContact.clientContactEmailModels[0].email = val;
    });

    if (this.activeClient.clientHuronContractModels && this.activeClient.clientHuronContractModels?.length > 0) {
      this.formGroup.controls[this.ContractNumber].setValidators([Validators.maxLength(50)]);
    }

    this.contractsControlEnableValidator(); 
    this.setLoadingStatus(false);
} 

    createApplicationFormCont(client: HhsgSharedClient) {
      if (client.clientApplicationModels)
        client.clientApplicationModels.forEach((app) => {
          this.formGroup.addControl("application" + app.applicationId, new FormControl(''));
        });
    }

    onEmailChangeEvent(event: any, i: number): void {
        this.markasDirty();
        this.newContact.clientContactEmailModels[i].email = event.target.value;
        this.newContactErrorMessageShow = false;
        let isFirstRow = false;
        let isValid = true;
        let newContact = this.newContact.clientContactEmailModels;

        if (newContact.length == 1) {
            if (newContact[0].email == "" || newContact[0].email == undefined) {               
                isFirstRow = true;                               
            }           
        }
        
        let j: number = 0
        newContact.forEach(x=>{
            let id = "contactEmail" + j;           
            if (!this.isContactEmailValid(x.email)) {
                if (!isFirstRow)
                {
                    document.getElementById(id).classList.add('ng-invalid');                    
                }  

                isValid = false;               
            }
            else {   
                document.getElementById(id).classList.remove('ng-invalid'); 
            }
            j++;

        });

        if (!isFirstRow && !isValid) {
            this.newContactErrorMessageShow = true;            
        }
        else
        {
            this.newContactErrorMessageShow = false;
        }
    }

    private setLoadingStatus(isLoading: boolean): void {
        if (isLoading) {
            this._tabControlService.announceTabLoading(this.tab.id);
        }
        else {
            this._tabControlService.announceTabFinishedLoading(this.tab.id);
        }
    }


  public getError(controlName: string, maxLength: number): string {
      let controlErrors = this.formGroup.controls[controlName]?.errors;

      if (controlErrors) {
        if ((Object.keys(controlErrors).some(s => s == 'required'))) {
          return controlName + " is required.";
        }
        else if ((Object.keys(controlErrors).some(s => s == 'duplicate'))) {
          return "This value is a duplicate.";
        }
        else if ((Object.keys(controlErrors).some(s => s == 'pattern'))) {
          return "The value should not have spaces.";
        }
        else if ((Object.keys(controlErrors).some(s => s == 'maxlength')) && maxLength) {
          return "The value cannot exceed more than " + maxLength + " characters.";
        }

      return '';
    }
  }

  /* this function is used to decode html encoded content */
  decodeEntities(str) {
    const element = document.createElement('div');
    if (str && typeof str === 'string') {
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = '';
    }
    return str;
  }
  public markasDirty() {
    this.formGroup.markAsDirty();
    this._formStateService.isFormDirty = true;
  }
  public findInvalidControls() {
    const invalid = [];
    const controls = this.formGroup.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

    cloneObject(source: any): any {
        const clone = JSON.parse(JSON.stringify(source));
        return clone;
    }

    changeSelectedStatus(event:any, activeClient: any): void{
        activeClient.isActive = event.target.value == "true";
    }

    checkFormIsDirty(): boolean {
        return this.formGroup.dirty || this._clickedActivatedApplications.length > 0 || this._clickedPurchasedApplications.length > 0;
    }

    clientHasActiveApplication(application: HhsgSharedApplication): boolean {
        if (this.activeClient.clientApplicationModels) {
            const clientApplicationIndex = this.getClientApplicationIndex(application);
            if (clientApplicationIndex >= 0 && this.activeClient.clientApplicationModels[clientApplicationIndex].isActive === true) {
                this.activeClient.clientApplicationModels[clientApplicationIndex].isPurchased = true;
                return true;
            }
        }

        return false;
    }

    clientHasPurchasedApplication(application: HhsgSharedApplication): boolean {
        if (this.activeClient.clientApplicationModels) {
            const clientApplicationIndex = this.getClientApplicationIndex(application);
            if (clientApplicationIndex >= 0 && this.activeClient.clientApplicationModels[clientApplicationIndex].isPurchased === true) {
                return true;
            }
        }
        return false;
    }
    
    isDependentApplicationInactive(application: HhsgSharedApplication){
        if(this.isHRIApplication(application.abbreviation)){
            let HuRIndex = this.getSpecifiedApplicationIndexByAbbreviation(Constants.HURAbbreviation);
            if(HuRIndex > -1){
                return this.activeClient.clientApplicationModels[HuRIndex].isPurchased ? false: true;
            }
            else{
                return  true;
            }
        }
        return false;
    }

    public isApplicationAccessTokenLifetimeInvalid(application: HhsgSharedApplication): boolean {
        if (this.clientHasActiveApplication(application) &&
            this.clientHasPurchasedApplication(application)) {
            let accessTokenLifetime = this.activeClient.clientApplicationModels[this.getClientApplicationIndex(application)].accessTokenLifetime;
            return accessTokenLifetime == null || accessTokenLifetime == undefined || accessTokenLifetime <= 0;
        }        
        return false;
    }

    public isApplicationIdentityTokenLifetimeInvalid(application: HhsgSharedApplication): boolean {
        if (this.clientHasActiveApplication(application) &&
            this.clientHasPurchasedApplication(application)) {
            let identityTokenLifetime = this.activeClient.clientApplicationModels[this.getClientApplicationIndex(application)].identityTokenLifetime;
            return identityTokenLifetime == null || identityTokenLifetime == undefined || identityTokenLifetime <= 0;
        }
        
        return false;
    }  

    isStuderApplication(applicationName: string): boolean {
        return applicationName.toUpperCase() === Constants.LeaderEvaluationManager ||
            applicationName.toUpperCase() === Constants.ValidationMatrix ||
            applicationName.toUpperCase() === Constants.PatientCallManager;
    }

    isHDVApplication(ApplicationAbbreviation: string): boolean {
        return ApplicationAbbreviation.toUpperCase() === Constants.CPIAbbreviation ||
            ApplicationAbbreviation.toUpperCase() === Constants.DMSAbbreviation  ||
            ApplicationAbbreviation.toUpperCase() === Constants.CBMAbbreviation;
    }
    isHRIApplication(ApplicationAbbreviation: string): boolean {
        return ApplicationAbbreviation.toUpperCase() === Constants.HRIAbbreviation;
    }
    isHuRApplication(ApplicationAbbreviation: string): boolean {
        return ApplicationAbbreviation.toUpperCase() === Constants.HURAbbreviation.toUpperCase();
    }

    isHDVApplicationSelected(): void {
        this.applications.forEach((app) => {
            if (app.abbreviation.toUpperCase() == Constants.HDVAbbreviation) {
                if(this.activeClient.id >= 1) {
                    let HDVIndex = this.getSpecifiedApplicationIndexByAbbreviation(Constants.HDVAbbreviation);

                    if(HDVIndex > -1) {
                        if(this.activeClient.clientApplicationModels[HDVIndex].isPurchased == false) {
                            this.activeClient.clientApplicationModels[HDVIndex].isPurchased = true;
                        }
                    }
                    else {
                        const clientApplication = new HhsgSharedClientApplication();
                        clientApplication.applicationName = app.name;
                        clientApplication.applicationId = app.id;
                        clientApplication.applicationAbbreviation = app.abbreviation;
                        clientApplication.clientId = this.activeClient.id;
                        clientApplication.isPurchased = true;
                        clientApplication.isActive = false;
                        clientApplication.accessTokenLifetime = 1800;
                        clientApplication.identityTokenLifetime = 180;
                        this.activeClient.clientApplicationModels.push(clientApplication);
                    }
                }
                else {
                    let localApplicationName = this.activeClient.clientApplicationModels.find(x => x.applicationId ==app.id);

                    if(localApplicationName == undefined) {
                        const clientApplication = new HhsgSharedClientApplication();
                        clientApplication.applicationName = app.name;
                        clientApplication.applicationId = app.id;
                        clientApplication.applicationAbbreviation = app.abbreviation;
                        clientApplication.clientId = this.activeClient.id;
                        clientApplication.isPurchased = true;
                        clientApplication.isActive = false;
                        clientApplication.accessTokenLifetime = 1800;
                        clientApplication.identityTokenLifetime = 180;
                        this.activeClient.clientApplicationModels.push(clientApplication);
                    }
                }
            }      
        });
    }

    public isHuronEmployee(): boolean {
        if (!this.user) {
            return false;
        }

        return RoleUtil.isHuronEmployee(this.user.roles);
    }

    isStuderApplicationSelected(): boolean {
        return this.activeClient && 
            this.activeClient.clientApplicationModels && 
            this.activeClient.clientApplicationModels.some(a => a.isActive && this.isStuderApplication(a.applicationName));
    }

    isVMorLEMSelected(): boolean {
        let anyChecked = false;

        if (this.activeClient && this.activeClient.clientApplicationModels) {
            this.activeClient.clientApplicationModels.forEach((app) => {
                if ((app.applicationName.toUpperCase() === Constants.LeaderEvaluationManager || app.applicationName.toUpperCase() === Constants.ValidationMatrix) &&
                    (app.isActive || app.isPurchased)) {
                    anyChecked = true;
                }
            });
        }

        return anyChecked;
    }

    isLEMFromName(name: string) {
        return name.toUpperCase() === Constants.LeaderEvaluationManager;
    }

    isHDVFromAbbreviation(abbreviation: string) {
        return abbreviation.toUpperCase() === Constants.HDVAbbreviation.toUpperCase();
    }

    isPCMFromName(name: string): boolean {
        return name.toUpperCase() === Constants.PatientCallManager;
    }

    isVMFromName(name: string): boolean {
        return name.toUpperCase() === Constants.ValidationMatrix;
    }
  
    initClientContactEmailArray(): void {        
        this.newContact.clientContactEmailModels = [ new HhsgSharedClientContactEmail() ];
    }

    private async loadCorporations(): Promise<void> {
        await this._corporationService.getAllActiveCorporations().then(async corps => {
            this.corporations = corps;
        });
    }   
   
  addClientContact(
    addNameInput: HTMLInputElement,
    addPhoneInput: HTMLInputElement,
    addRoleInput: HTMLInputElement,
    addNotesInput: HTMLInputElement,
    addEmailList: HTMLUListElement
  ): boolean {

        this.newContactValidName = true;
        this.newContactValidEmail = true;
        this.newContactValidPhone = true;

    var contactName = addNameInput.value;
    var contactPhone = addPhoneInput.value;
    var roleOrTitle = addRoleInput.value;
    var contactNotes = addNotesInput.value;


    const addEmailInputs = addEmailList.querySelectorAll('input');

    for (let i: number = 0; i < addEmailInputs.length; i++) {
      if (!this.isContactEmailValid(addEmailInputs[i].value)) {
        this.newContactValidEmail = false;
        break;
      }
    }

        
   

    if (addEmailInputs.length) {
    this.newContact.clientContactEmailModels = [];
      for (let i = 0; i < addEmailInputs.length; i++) {
        if (addEmailInputs[i].value) {
          const emailModel = new HhsgSharedClientContactEmail();

          emailModel.email = addEmailInputs[i].value;
          this.newContact.clientContactEmailModels.push(emailModel);
        }
      }
    }


      this.newContact.name = contactName;
      this.newContact.phone = contactPhone;
      this.newContact.roleOrTitle = roleOrTitle;
      this.newContact.notes = contactNotes;

        if (!this.newContact.name) {          
            this.formGroup.get('contactName').setValidators([Validators.required]);    
            this.formGroup.get('contactName').updateValueAndValidity();    
        }

        if (!this.isNewContactEmailValid(this.newContact)) {
          this.newContactValidEmail = false;
          if (this.newContact.clientContactEmailModels.length == 0)
            this.initClientContactEmailArray();
        }

        if (!this.isContactPhoneValid(this.newContact.phone, true)) {
            this.newContactValidPhone = false;
        }

    if (!this.newContactValidName || !this.newContactValidEmail || !this.newContactValidPhone) {     
            return false;
        }

        const applications: HhsgSharedClientContactApplication[] = [];

        if (!this.activeClient.clientContactModels) {
            this.activeClient.clientContactModels = [];
        }

        if (this.$newContactAppIds.size) {
            for (let i = 0; i < this.$newContactAppIds.size; i++) {
                const contactApp = new HhsgSharedClientContactApplication();
                contactApp.applicationId = +this.newContactAppIds[i];
                applications.push(contactApp);
            }
        }

        this.newContact.clientContactApplicationModels = applications;

        this.activeClient.clientContactModels.push(this.newContact);
        this.newContact = new HhsgSharedClientContact();
        this.initClientContactEmailArray();
        this.newContactAppIds = [];
        this.newContactValidName = true;

        this.formGroup.get(this.ContactName).setValue('');
        this.formGroup.get(this.Phone).setValue('');
        this.formGroup.get(this.RoleOrTitle).setValue('');
        this.formGroup.get(this.ContactNotes).setValue('');             

        return false;
    }

    isContactPhoneValid(phoneNumber: string, isNew: boolean): boolean {
        this.newContactValidPhone = true;
        this.editedContactValidPhone = true;

        // occurrs when Add Contact is clicked w/o entering anything
        // this prevents the red border making phone seem required
        if (!phoneNumber) {
            return true;
        }

        if (isNew) {
            this.newContactValidPhone = Constants.PhoneRegEx.test(phoneNumber);
            return this.newContactValidPhone;
        } 
        else {
            this.editedContactValidPhone = Constants.PhoneRegEx.test(phoneNumber);
            return this.editedContactValidPhone;
        }
    }

    isContactEmailValid(email: string): boolean {
        return Constants.EmailRegEx.test(email);
    }

    isNewContactEmailValid(contact: HhsgSharedClientContact): boolean {
        if (!contact || !contact.clientContactEmailModels || contact.clientContactEmailModels.length === 0) {
            return false;
        }

        let isValid = true;

        contact.clientContactEmailModels.forEach(e => {
            if (!e || !e.email || !this.isContactEmailValid(e.email)) {
                isValid = false;
            }
        });

        return isValid;
    }

    clearClientContact(): boolean {
        
        this.newContact = new HhsgSharedClientContact();
        this.initClientContactEmailArray();
        this.newContactAppIds = [];
        this.newContactValidName = true;
        this.formGroup.get(this.ContactName).setValue('');
        this.formGroup.get(this.Phone).setValue('');
        this.formGroup.get(this.RoleOrTitle).setValue('');
        this.formGroup.get(this.ContactNotes).setValue('');  
        this.newContactErrorMessageShow = false;
        return false;
    }

  editClientContact(index: number): boolean {
    this.markasDirty();

    if (this.isaHuronEmployee) {
      if (this.activeClient.clientContactModels[index]) {
        this.activeClient.clientContactModels[index].isEditing = true;

        this.formGroup.controls['editContactName'].setValue(this.activeClient.clientContactModels[index].name);
        this.formGroup.controls['editPhone'].setValue(this.activeClient.clientContactModels[index].phone);
        this.formGroup.controls['editRoleOrTitle'].setValue(this.activeClient.clientContactModels[index].roleOrTitle);
        this.formGroup.controls['editContactNotes'].setValue(this.activeClient.clientContactModels[index].notes);

      }
    }
    return false;
    }

  removeClientContact(index: number): boolean {
    this.markasDirty();

    if (this.isaHuronEmployee) {
      this.activeClient.clientContactModels.splice(index, 1);
    }
    return false;
    }

    addEditClientContactEmail(contact: HhsgSharedClientContact): boolean {
        if (!contact.clientContactEmailModels) {
            contact.clientContactEmailModels = [];
        }

        contact.clientContactEmailModels.push(new HhsgSharedClientContactEmail());
        this.editContactErrorMessageShow = true;
        return false;
    }

    cancelEditContact(index: number): boolean {
        this.editedContactValidName = true;
        this.editedContactValidEmail = true;
        this.editedContactValidPhone = true;
        if (this.activeClient.clientContactModels[index]) {
            delete this.activeClient.clientContactModels[index].isEditing;
        }

        return false;
    }

    saveEditContact(
        nameInput: HTMLInputElement, 
        phoneInput: HTMLInputElement, 
        roleInput: HTMLInputElement, 
        notesInput: HTMLInputElement, 
        emailList: HTMLUListElement, 
        appList: HTMLUListElement, 
        index: number): boolean {
        this.setLoadingStatus(true);
        this.editedContactValidName = true;
        this.editedContactValidEmail = true;
        this.editedContactValidPhone = true;

        const appInputs = appList.querySelectorAll('input');
        const emailInputs = emailList.querySelectorAll('input');
        const currContact = this.activeClient.clientContactModels[index];

        if (!currContact) {
            return false;
        }

        if (!nameInput.value) {
            this.editedContactValidName = false;
        }

        if (!this.isContactPhoneValid(phoneInput.value, false)) {
            this.editedContactValidPhone = false;
        }

        for (let i: number = 0; i < emailInputs.length; i++) {
            if (!this.isContactEmailValid(emailInputs[i].value)) {
                this.editedContactValidEmail = false;
                break;
            }
        }

        if (!this.editedContactValidName || !this.editedContactValidPhone || !this.editedContactValidEmail) {
            return false;
        }

        currContact.name = nameInput.value;
        currContact.phone = phoneInput.value;
        currContact.roleOrTitle = roleInput.value;
        currContact.notes = notesInput.value;
        currContact.clientContactApplicationModels = [];

        if (appInputs.length) {
            for (let i = 0; i < appInputs.length; i++) {
                if (appInputs[i].checked) {
                    const appModel = new HhsgSharedClientContactApplication();

                    appModel.applicationId = parseInt(appInputs[i].value, null);
                    currContact.clientContactApplicationModels.push(appModel);
                }
            }
        }

        currContact.clientContactEmailModels = [];

        if (emailInputs.length) {
            for (let i = 0; i < emailInputs.length; i++) {
                if (emailInputs[i].value) {
                    const emailModel = new HhsgSharedClientContactEmail();

                    emailModel.email = emailInputs[i].value;
                    currContact.clientContactEmailModels.push(emailModel);
                }
            }
        }

        delete this.activeClient.clientContactModels[index].isEditing;
        this.cancelEditContact(index);
        this.setLoadingStatus(false);

        return false;
    }

    contactHasApplication(contact: HhsgSharedClientContact, applicationId: number): boolean {
        return contact && 
            contact.clientContactApplicationModels && 
            contact.clientContactApplicationModels.findIndex(x => x.applicationId === applicationId) >= 0;
    }

    newContactHasApp(appId: number): boolean {
        return this.$newContactAppIds.has(appId);
    }

    getApplicationNameById(id: number): string {
        let name = '';

        if (this.activeClient.clientApplicationModels) {
            name = this.activeClient.clientApplicationModels.find(app => app.applicationId === id).applicationName;
        }

        return name;
    }

    getApplicationIdByName(name: string): number {
        let id = -1;

        if (this.activeClient.clientApplicationModels) {
            id = this.activeClient.clientApplicationModels.find(app => app.applicationName.toUpperCase() === name.toUpperCase()).applicationId;
        }

        return id;
    }

    addAsteriskForPCMandVM(appName: string): string {
        var returnValue = "";

        if (appName.toUpperCase() === Constants.LeaderEvaluationManager || appName.toUpperCase() === Constants.ValidationMatrix) {
            returnValue = "*";
        }

        return returnValue;
  } 

    clientContactAppChecked(appInput: HTMLInputElement): void {
        if (appInput.checked) this.$newContactAppIds.set(+appInput.value, +appInput.value);
        else this.$newContactAppIds.delete(+appInput.value);
    }

  addClientContactEmail(): boolean {
    var clientContactEmail = new HhsgSharedClientContactEmail();
    this.newContact.clientContactEmailModels.push(clientContactEmail);     
    this.newContactErrorMessageShow = true; 
    return false;
    }

    removeClientContactEmail(contact: HhsgSharedClientContact, index: number): boolean {
        contact.clientContactEmailModels.splice(index, 1);

        return false;
    }

  addClientAKA(): boolean {
    var newAkaValue = this.formGroup.get("newaka").value;
    this.newAka.aka = newAkaValue;
        if (this.newAka.aka) {
            if (!this.activeClient.clientAkaModels) {
                this.activeClient.clientAkaModels = [];
            }

            this.newAka.isNew = true;
            this.activeClient.clientAkaModels.push(this.newAka);

          this.newAka = new HhsgSharedClientAKA();
          this.formGroup.get("newaka").setValue('');
            this.newAkaError = false;

        } 
        else {
            this.newAkaError = true;
        }

        return false;
    }

  clearClientAKA(): boolean {
        this.formGroup.get("newaka").setValue('');
        this.newAka = new HhsgSharedClientAKA();
    this.newAkaError = false;

    if (this.activeClient.clientHuronContractModels && this.activeClient.clientHuronContractModels?.length > 0) {
      this.formGroup.controls[this.ContractNumber].setValidators([Validators.maxLength(50)]);
    }

        return false;
    }

  removeClientAKA(index: number): boolean {
    this.markasDirty();

    if (this.isaHuronEmployee) {
      this.activeClient.clientAkaModels.splice(index, 1);
    }
    if (this.activeClient.clientHuronContractModels && this.activeClient.clientHuronContractModels?.length > 0) {
      this.formGroup.controls[this.ContractNumber].setValidators([Validators.maxLength(50)]);
    }
    return false;
    }

  editClientAKA(index: number): boolean {
    this.markasDirty();
    
    if (this.isaHuronEmployee) {
        if (this.activeClient.clientAkaModels[index]) {
          this.activeClient.clientAkaModels[index].isEditing = true;
          this.formGroup.controls['editAka'].setValue(this.activeClient.clientAkaModels[index].aka);
        }
      }
       return false;
    }

    cancelClientAKAEdit(index: number): boolean {
        if (this.activeClient.clientAkaModels[index]) {
            delete this.activeClient.clientAkaModels[index].isEditing;
        }

        return false;
    }

    saveClientAKAEdit(akaInput: HTMLInputElement, index: number): boolean {
        if (this.activeClient.clientAkaModels[index] && akaInput.value) {
            this.activeClient.clientAkaModels[index].aka = akaInput.value;
            this.activeClient.clientAkaModels[index].isNew = true;
            this.cancelClientAKAEdit(index);
        }

        return false;
    }

    showEditError(editInput: HTMLInputElement): boolean {
        return !editInput.validity.valid;
  }
  
  addHuronContract(): boolean {
    var contractNumber = this.formGroup.get(this.ContractNumber).value;
    var contractName = this.formGroup.get(this.ContractName).value;
    var contractNotes = this.formGroup.get(this.ContractNotes).value;
    if (contractNumber)
        {
      this.newHuronContract.number = contractNumber;
      this.newHuronContract.name = contractName;
      this.newHuronContract.notes = contractNotes;
            if (!this.activeClient.clientHuronContractModels) {
                this.activeClient.clientHuronContractModels = [];
            }

            this.newHuronContract.isNew = true;
      this.activeClient.clientHuronContractModels.push(this.newHuronContract);
      this.formGroup.controls[this.ContractNumber].setValidators([Validators.maxLength(50)]);
            this.newHuronContract = new HhsgSharedHuronContract();
      this.newHuronContractError = false;
      this.formGroup.get(this.ContractNumber).setValue('');
      this.formGroup.get(this.ContractName).setValue('');
      this.formGroup.get(this.ContractNotes).setValue('');
        } 
        else {
      this.newHuronContractError = true;
        }
   
        return false;
    }

  clearHuronContract(): boolean {
        this.formGroup.get(this.ContractNumber).setValue('');
        this.formGroup.get(this.ContractName).setValue('');
        this.formGroup.get(this.ContractNotes).setValue('');
        this.newHuronContract = new HhsgSharedHuronContract();
        this.newHuronContractError = false;

        return false;
    }

  removeHuronContract(index: number): boolean {
      this.markasDirty();

      if (this.isaHuronEmployee) {
          this.activeClient.clientHuronContractModels.splice(index, 1);
      }
      this.contractsControlEnableValidator();
      return false;
    }
  
  editHuronContract(index: number): boolean {
      this.markasDirty();

      if (this.isaHuronEmployee) {
          if (this.activeClient.clientHuronContractModels[index]) {
              this.activeClient.clientHuronContractModels[index].isEditing = true;
              this.formGroup.controls['editContractName'].setValue(this.activeClient.clientHuronContractModels[index].name);
              this.formGroup.controls['editContractNumber'].setValue(this.activeClient.clientHuronContractModels[index].number);
              this.formGroup.controls['editContractNotes'].setValue(this.activeClient.clientHuronContractModels[index].notes);
          }
      }
      return false;
    }

    cancelEditHuronContract(index: number): boolean {
        if (this.activeClient.clientHuronContractModels[index]) {
            delete this.activeClient.clientHuronContractModels[index].isEditing;
        }

        return false;
  }

  SetAccessTokenValue(accessToken: HTMLInputElement,
    application: HhsgSharedApplication): boolean {       
    if (this.activeClient.clientApplicationModels[this.getClientApplicationIndex(application)] && accessToken.value)
      this.activeClient.clientApplicationModels[this.getClientApplicationIndex(application)].accessTokenLifetime = Number(accessToken.value)
    return false;
  }

  SetIdentityTokenValue(identityToken: HTMLInputElement,
    application: HhsgSharedApplication): boolean {
    if (this.activeClient.clientApplicationModels[this.getClientApplicationIndex(application)] && identityToken.value)
      this.activeClient.clientApplicationModels[this.getClientApplicationIndex(application)].identityTokenLifetime = Number(identityToken.value)
    return false;
  }
  SetMarketplaceProductCode(marketPlaceProductCode: HTMLInputElement,
    application: HhsgSharedApplication): boolean {
    if (this.activeClient.clientApplicationModels[this.getClientApplicationIndex(application)] && marketPlaceProductCode.value)
      this.activeClient.clientApplicationModels[this.getClientApplicationIndex(application)].awsMarketplaceProductCode = marketPlaceProductCode.value
    return false;
  }
  SetMarketplaceCustomerId(marketPlaceCustomerId: HTMLInputElement,
    application: HhsgSharedApplication): boolean {
    if (this.activeClient.clientApplicationModels[this.getClientApplicationIndex(application)] && marketPlaceCustomerId.value)
      this.activeClient.clientApplicationModels[this.getClientApplicationIndex(application)].awsMarketplaceCustomerId = marketPlaceCustomerId.value
    return false;
  }

    saveEditHuronContract(
        nameInput: HTMLInputElement, 
        numberInput: HTMLInputElement, 
        notesInput: HTMLInputElement, 
        index: number): boolean {
        if (this.activeClient.clientHuronContractModels[index] && numberInput.value) {
            this.activeClient.clientHuronContractModels[index].name = nameInput.value;
            this.activeClient.clientHuronContractModels[index].number = numberInput.value;
            this.activeClient.clientHuronContractModels[index].notes = notesInput.value;
            this.activeClient.clientHuronContractModels[index].isNew = true;
            this.cancelEditHuronContract(index);            
        }

        return false;
    }

  onClientApplicationChecked(e: Event | any, application: HhsgSharedApplication): void {
        if (!this.activeClient.clientApplicationModels) {
            this.activeClient.clientApplicationModels = [];
        }

        let applicationIndex = this.getClientApplicationIndex(application);

        if (applicationIndex >= 0) {
            this.activeClient.clientApplicationModels[applicationIndex].isActive = !this.activeClient.clientApplicationModels[applicationIndex].isActive;
            this.formGroup.addControl("application" + this.activeClient.clientApplicationModels[applicationIndex].applicationId, new FormControl(''));
        } 
        else {
            const clientApplication = new HhsgSharedClientApplication();
            clientApplication.applicationName = application.name;
            clientApplication.applicationId = application.id;
            clientApplication.clientId = this.activeClient.id;
            clientApplication.isActive = true;
            clientApplication.accessTokenLifetime = 1800;
            clientApplication.identityTokenLifetime = 180;
            this.activeClient.clientApplicationModels.push(clientApplication);
            applicationIndex = this.getClientApplicationIndex(application);
        }

        // LEM and VM are mutually exclusive so we must uncheck one if the opposite was just checked.
        // We DO NOT check the opposite if the other one was just unchecked however.
        if (applicationIndex > -1 && this.activeClient.clientApplicationModels[applicationIndex].isActive) {
            if (this.isVMFromName(application.name)) { // VM was just checked and we need to make sure LEM is not checked here
                let lemIndex = this.getSpecifiedApplicationIndexByName("Leader Evaluation Manager");

                if (lemIndex > -1) {
                    this.activeClient.clientApplicationModels[lemIndex].isActive = false;
                }
            } 
            else {
                if (this.isLEMFromName(application.name)) { // LEM was just checked and we need to make sure VM is not checked here
                    let vmIndex = this.getSpecifiedApplicationIndexByName("Validation Matrix");
                    if (vmIndex > -1) {
                        this.activeClient.clientApplicationModels[vmIndex].isActive = false;
                    }
                }
            }
        }

        this._organizationService.setOrganizationLegend(this.activeClient);
        this._organizationService.isVMorLEMSelected = this.isVMorLEMSelected();

        if (this._clickedActivatedApplications.indexOf(application.id) > -1) {
            this._clickedActivatedApplications.splice(this._clickedActivatedApplications.indexOf(application.id), 1);
        } 
        else {
            this._clickedActivatedApplications.push(application.id);
        }

    this._formStateService.isFormDirty = this.checkFormIsDirty();
    this.markasDirty();
    }

    // This cancel need as its a member of Interface HhsgSharedTabInterface. 
    // It need to override to implement functionality on cancel 
    public async cancel(): Promise<void> {
        this.setLoadingStatus(true);
        await this.reload();
        this.setLoadingStatus(false);
    }

    public async reload(): Promise<void> {
        this.setLoadingStatus(true);
        this.formGroup.reset(this.formGroup.value);
        await this.createForm();
        await this.initLoading();
        this.setLoadingStatus(false);
    }

    public isDisabled(): boolean {
        return false;
    }

    public isFormDirty(): boolean {
        if (this.formGroup.dirty) {
            // If the form is dirty then hide all the tabs that are saved to the user.
            this.activeClient?.clientApplicationModels?.filter(u => !u.isActive).forEach(u => {
                this._tabControlService.announceTabHidden(u.applicationAbbreviation);
            });

            // If the form is dirty then hide all the tabs that have been added but not saved.
            this.activeClientApplications.forEach(a => {
                this._tabControlService.announceTabHidden(a.abbreviation);
            });
        }
        else {
            // Get a list of the applications saved to the user.  It is not necessary to announce the ones added since the last save
            // because all tabs are hidden when the form is dirty.
            let visibleApplications = this.activeClient?.clientApplicationModels
                ?.filter(u =>
                    u.isActive &&
                    this.checkUserApplicationMappingStatus(u.applicationId))
                ?.map(u => u.applicationAbbreviation);

            // If the form is not dirty then show all the tabs that are saved to the user.
            visibleApplications?.forEach(abbreviation => {
                this._tabControlService.announceTabVisible(abbreviation);
            });
        }
        return this.formGroup.dirty;
    }
    public checkUserApplicationMappingStatus(applicationId: number): boolean {
        return this.applications?.some(a => a.id == applicationId);
    }

    public isFormValid(): boolean {
        return !(this.showOrganizationError() || this.showContractError() || this.imageSizeError || this.formGroup.invalid);
    }

    public async save(): Promise<number> {
        //there is no event required here so passing null to onSubmit
        if(this.onSubmit(null)){
            let saveResult = await this.onConfirmSaving(null);
            if (saveResult) { 
                this.errorMessages = [Constants.SaveSuccess];
                this.setLoadingStatus(true);                    
                return 1;
            }
            else {
                if(this.errorMessages.length == 0) {
                this.errorMessages = [ "An error occurred during save." ];
                }
                return -1;
            }
        }
        
    } 


    onClientApplicationPurchasedChecked(e: Event | any, application: HhsgSharedApplication): void {
        if (!this.activeClient.clientApplicationModels) {
          this.activeClient.clientApplicationModels = [];
        }

        let applicationIndex = this.getClientApplicationIndex(application);

        if (applicationIndex >= 0) {
            this.activeClient.clientApplicationModels[applicationIndex].isPurchased = !this.activeClient.clientApplicationModels[applicationIndex].isPurchased;
            
            if (!this.activeClient.clientApplicationModels[applicationIndex].isPurchased) {
                this.activeClient.clientApplicationModels[applicationIndex].isActive = false;
                if (!this.activeClient.id || this.activeClient.id < 1) { // if this is an add situation remove the application from array
                    this.activeClient.clientApplicationModels.splice(applicationIndex, 1);
                    applicationIndex = -1;
                }
            }
        } 
        else {
            const clientApplication = new HhsgSharedClientApplication();
            clientApplication.applicationName = application.name;
            clientApplication.applicationId = application.id;
            clientApplication.applicationAbbreviation = application.abbreviation;
            clientApplication.clientId = this.activeClient.id;
            clientApplication.isPurchased = true;
            clientApplication.isActive = false;
            clientApplication.accessTokenLifetime = 1800;
            clientApplication.identityTokenLifetime = 180;
            this.activeClient.clientApplicationModels.push(clientApplication);
            applicationIndex = this.getClientApplicationIndex(application);
        }
        // LEM and VM are mutually exclusive so we must uncheck one if the opposite was just checked.
        // We DO NOT check the opposite if the other one was just unchecked however.
        if (applicationIndex > -1 && 
            (this.activeClient.clientApplicationModels[applicationIndex].isActive || this.activeClient.clientApplicationModels[applicationIndex].isPurchased)) {
            if (this.isVMFromName(application.name)) { // VM was just checked and we need to make sure LEM is not checked here
                let lemIndex = this.getSpecifiedApplicationIndexByName("Leader Evaluation Manager");

                if (lemIndex > -1) {
                    this.activeClient.clientApplicationModels[lemIndex].isPurchased = false;
                    this.activeClient.clientApplicationModels[lemIndex].isActive = false;
                }
            } 
            else {
                if (this.isLEMFromName(application.name)) { // LEM was just checked and we need to make sure VM is not checked here
                    let vmIndex = this.getSpecifiedApplicationIndexByName("Validation Matrix");

                    if (vmIndex > -1) {
                        this.activeClient.clientApplicationModels[vmIndex].isPurchased = false;
                        this.activeClient.clientApplicationModels[vmIndex].isActive = false;
                    }
                }
            }
        }
        if (this.isHuRApplication(application.abbreviation)){
            let HuRIndex = this.getSpecifiedApplicationIndexByAbbreviation(Constants.HURAbbreviation);
            let HRIIndex = this.getSpecifiedApplicationIndexByAbbreviation(Constants.HRIAbbreviation);
            if(
                (HuRIndex == -1 || this.activeClient.clientApplicationModels[HuRIndex].isPurchased == false)
                && this.activeClient.clientApplicationModels[HRIIndex]
            ){
                this.activeClient.clientApplicationModels[HRIIndex].isPurchased = false;
                this.activeClient.clientApplicationModels[HRIIndex].isActive = false;
            }    
        }


        if (applicationIndex > -1 && 
            (this.activeClient.clientApplicationModels[applicationIndex].isActive || this.activeClient.clientApplicationModels[applicationIndex].isPurchased) &&
            this.isHDVApplication(application.abbreviation)) {
            this.isHDVApplicationSelected();        
        }

        if(e.target.checked == false && this.isHDVFromAbbreviation(application.abbreviation)) {
            this.applications.forEach((app) => {
                this.HDVUnselection(app.abbreviation);
            });
        }

        this._organizationService.setOrganizationLegend(this.activeClient);
        this._organizationService.isVMorLEMSelected = this.isVMorLEMSelected();

        if (this._clickedPurchasedApplications.indexOf(application.id) > -1) {
            this._clickedPurchasedApplications.splice(this._clickedPurchasedApplications.indexOf(application.id), 1);
        } 
        else {
            this._clickedPurchasedApplications.push(application.id);
        }

      this._formStateService.isFormDirty = this.checkFormIsDirty();
      this.markasDirty();
    }

    HDVUnselection(abbreviation: string) {
        if (abbreviation.toUpperCase() === Constants.CPIAbbreviation || 
            abbreviation.toUpperCase() === Constants.DMSAbbreviation ||
            abbreviation.toUpperCase() === Constants.CBMAbbreviation) {
            let Index = this.getSpecifiedApplicationIndexByAbbreviation(abbreviation);

            if(this.activeClient.id >= 1 && Index > -1 && this.activeClient.clientApplicationModels[Index].isPurchased) {
                this.activeClient.clientApplicationModels[Index].isPurchased = false;
                this.activeClient.clientApplicationModels[Index].isActive = false;                                    
            }
            else {
                if (Index > -1 && this.activeClient.clientApplicationModels[Index].isPurchased) {
                    this.activeClient.clientApplicationModels.splice(Index, 1);                    
                }
            }
        }
    }

    getClientApplicationIndex(application: HhsgSharedApplication): number {
        if (!this.activeClient.clientApplicationModels) {
            return -1;
        }

        return this.activeClient.clientApplicationModels.findIndex(x => x.applicationId === application.id); // returns -1 if not found
    }

    getSpecifiedApplicationIndexByName(name: string): number {
        if (!this.activeClient.clientApplicationModels) {
            return -1;
        }

        return this.activeClient.clientApplicationModels.findIndex(x => x.applicationName === name); // returns -1 if not found
    }

    getSpecifiedApplicationIndexByAbbreviation(abbreviation: string): number {
        if (!this.activeClient.clientApplicationModels) {
            return -1;
        }

        return this.activeClient.clientApplicationModels.findIndex(x => x.applicationAbbreviation === abbreviation); // returns -1 if not found
    }

    onSubmit(e: Event | any): boolean {
        this.isSubmitted = true;
        this.newHuronContractError = false;
        this.organizationError = false;
        this.errorMessages = [];

        if (this.showOrganizationError()) {
            this.errorMessages.push(Constants.ValidationFailure);
            this.confirmSaving = false;
            return false;
      }      
      if (this.showContractError()) {
            this.errorMessages.push(Constants.ValidationFailure);
            this.confirmSaving = false;
            return false; 
      }
      if (this.formGroup.valid && !this.imageSizeError) {
        this.confirmSaving = true;  
        return true;     
      }
      else {
          this.confirmSaving = false;
          console.log(this.findInvalidControls());
          this.errorMessages.push(Constants.ValidationFailure);
          return false;
      }
  }
 private async onConfirmSaving(e: Event | any): Promise<boolean> {
    this.loadingCls = "loading";
    this.confirmSaving = false;
    this.setLoadingStatus(true);
    this._formData = new FormData();
    this.errorMessages = [];
    this.isSaving = true;
    this.isEditing = false;
    this.activeClient.name = this.formGroup.get('name').value;
    this.activeClient.websiteUrl = this.formGroup.get('website').value;    
    this.activeClient.address1 = this.formGroup.get('address1').value;
    this.activeClient.address2 = this.formGroup.get('address2').value;
    this.activeClient.city = this.formGroup.get('city').value;
    this.activeClient.geoRegion = this.formGroup.get('state').value;
    this.activeClient.postalCode = this.formGroup.get('zip').value;
    this.activeClient.removeExistingLogo = this.formGroup.get('deleteClientLogo').value ? true : false;
    this.activeClient.timeZoneId = this.formGroup.get('timeZoneId').value;

    let timezoneControl = this.formGroup.controls['timeZoneId'];
    if(timezoneControl && this.activeClient.timeZoneId  && this.activeClient.timeZoneId .length > 0) {
      timezoneControl.reset({ disabled: true, value: this.activeClient.timeZoneId  });
    }
    
    if (!this.activeClient.id) {
      this.activeClient.accountNumber = this.formGroup.get('accountNumber').value;
      this.activeClient.corporationId = this.formGroup.get('corporationId').value;
    }

        // This must be outside of if stmt in case all studer apps were unchecked. Otherwise SG Portal db does not get updated.
        this.setPortalApplicationAuthorization();

        if (this.isStuderApplicationSelected()) {
            this.syncClientToOrganization();

            if (this.logoToUpload) {
                this._formData.append(this.logoToUpload.name, this.logoToUpload);
            }
            this._formData.append('json', JSON.stringify(this.activeClient));
            let sqPortalUpsertResult = await this._clientAdminService.upsert(this._formData).then(async (client) => {
                this.activeClient = client;
                await this._organizationService.saveOrganization(this._organizationService.currentOrganization).then(async (result) => {
                 await   this._organizationService.getOrganization(result).then(async (result) => {
                        this._organizationService.currentOrganization = result;
                        client.clientApplicationModels.forEach((c) => {
                            if (c.applicationName.toUpperCase() === Constants.LeaderEvaluationManager ||
                                c.applicationName.toUpperCase() === Constants.PatientCallManager ||
                                c.applicationName.toUpperCase() === 'STUDER GROUP PORTAL' ||
                                c.applicationName.toUpperCase() === Constants.ValidationMatrix) {
                                c.childApplicationClientId = result.id;
                            }
                        });

                        await this._applicationService.saveClientApplications(client.clientApplicationModels);
                        await this._organizationService.createSgPortalDbAdminUsers(client, this.user.email);
                        await this.syncContactsToSgPortal(client);
                        this.errorMessages.push(Constants.SaveSuccess);
                        this.onAfterSaveClient(client);
                        this._formStateService.isFormDirty = false;
                        return true;
                    });
                    this.setLoadingStatus(false);
                },
                (error) => {
                    this.errorMessages.push(Constants.OrganizationSaveError);
                    this.isEditing = true;
                    this.isSaving = false;   
                    this.setLoadingStatus(false);
                    return false;
                });
                return true;
            },
            (error) => {
                this.errorMessages.push(Constants.ClientUpsertError);
                this.isEditing = true;
                this.isSaving = false;
                this.setLoadingStatus(false);
                return false;
            });

            return sqPortalUpsertResult;
        } 
        else {
            if (this.activeClient.clientApplicationModels && this.activeClient.clientApplicationModels.length > 0) {
                this.activeClient.clientApplicationModels.forEach(clientApplication => {
                    if (clientApplication.applicationId || clientApplication.applicationId === 0) {
                        clientApplication.applicationId = this.getApplicationIdByName(clientApplication.applicationName);
                    }
                });
            }

            this._formData.append('json', JSON.stringify(this.activeClient));

            if (this.logoToUpload) {
                this._formData.append(this.logoToUpload.name, this.logoToUpload);
            }

           let upsertResult =  await this._clientAdminService.upsert(this._formData).then(async (client) => {
                this.errorMessages.push(Constants.SaveSuccess);
                this.onAfterSaveClient(client);  
                this.setLoadingStatus(false);
                this._formStateService.isFormDirty = false;
                return true;             
            },
            (error) => {
              this.errorMessages.push(this.decodeEntities(error.error));
                this.isEditing = true;
                this.isSaving = false;
                this.setLoadingStatus(false);
                return false;
            });
            return upsertResult;
        }
    }

    syncClientToOrganization() {
        this._organizationService.currentOrganization.name = this.activeClient.name;

        if (this.activeClient.address1) {
            this._organizationService.currentOrganization.address1 = this.activeClient.address1;
        } 
        else {
            this._organizationService.currentOrganization.address1 = '';
        }

        if (this.activeClient.address2) {
            this._organizationService.currentOrganization.address2 = this.activeClient.address2;
        } 
        else {
            this._organizationService.currentOrganization.address2 = '';
        }

        if (this.activeClient.city) {
            this._organizationService.currentOrganization.city = this.activeClient.city;
        } 
        else {
            this._organizationService.currentOrganization.city = '';
        }

        if (this.activeClient.postalCode) {
            this._organizationService.currentOrganization.zip = this.activeClient.postalCode;
        } 
        else {
            this._organizationService.currentOrganization.zip = '';
        }
    }

    async syncContactsToSgPortal(client: HhsgSharedClient) {
        if (!client.clientContactModels || client.clientContactModels.length === 0) {
            await this._clientAdminService.getStuderOrgId(client.id).then((result) => {
                if (result) {
                    this._supportContactService.deleteSgPortalContacts(result);
                }
            });

            return;
        }

        const contactModels: HhsgSharedStuderSupportContact[] = [];

        client.clientContactModels.forEach((cm) => {
            let scm = new HhsgSharedStuderSupportContact();

            scm.name = cm.name;
            scm.phone1 = cm.phone;
            scm.isDeleted = false;

            scm.organizationId = this._organizationService.currentOrganization.id;

            if (!scm.organizationId) {
                return;
            }

            if (cm.clientContactEmailModels && cm.clientContactEmailModels.length > 0) {
                scm.email = cm.clientContactEmailModels[0].email;
            }

            if (cm.clientContactApplicationModels && cm.clientContactApplicationModels.length > 0) {
                cm.clientContactApplicationModels.forEach((cam) => {
                    scm.hapApplicationIds.push(cam.applicationId);
                });
            }

            contactModels.push(scm);
        });

        this._supportContactService.saveContactsToSgPortal(contactModels);
    }

    // this is based on the activeClient and the currentOrganization
    setPortalApplicationAuthorization() {

        if (!this._organizationService.currentOrganization) {
            return;
        }

        this._organizationService.currentOrganization.isDeleted = !this.activeClient.isActive;
        this._organizationService.currentOrganization.isLemAuthorized = false;
        this._organizationService.currentOrganization.isMMMAuthorized = false;
        this._organizationService.currentOrganization.isDcmAuthorized = false;
        this._organizationService.currentOrganization.isPfsAuthorized = false;

        if (!this._activeClient.clientApplicationModels) {
            return;
        }

        this._activeClient.clientApplicationModels.forEach(clientApplication => {            
            if (this.isLEMFromName(clientApplication.applicationName)) {
                this._organizationService.currentOrganization.isLemAuthorized = clientApplication.isActive;
            }
            if (this.isVMFromName(clientApplication.applicationName)) {
                this._organizationService.currentOrganization.isMMMAuthorized = clientApplication.isActive;
            }
            if (this.isPCMFromName(clientApplication.applicationName)) {
                this._organizationService.currentOrganization.isDcmAuthorized = clientApplication.isActive;
            }
        });
    }

    saveFile(files: any) {
        this._formData = new FormData();

        if (files.length === 0) {
            this.imageSizeError = false;
            this.isLogoAttachmentSuccessful = false;
            return;
        }

        if (files[0].size > 2000000) {
            this.imageSizeError = true;
            this.isLogoAttachmentSuccessful = false;
        } 
        else {
            this.logoToUpload = files[0];
            this._formData.append(this.logoToUpload.name, this.logoToUpload);
            this.imageSizeError = false;
            this.isLogoAttachmentSuccessful = true;
      }
      this.markasDirty();
    }

  private onAfterSaveClient(client: HhsgSharedClient) {
        this.createApplicationFormCont(client);
        this.activeClient = client;
        if(client.timeZoneId?.length > 0) {
           this.formGroup.get('timeZoneId').reset({ disabled: true, value: client.timeZoneId });
        }
        this.updateSuccess = true;
        this.errorMessages = [];
        this.isEditing = false;
        this.isSaving = false;
        this._clientAdminService.announceActiveClient(this.activeClient);         
        this._routerService.navigate(["/admin/client/edit/"+this.activeClient.id]);
    }

    onCancelEditing() {
        this.isEditing = false;        
        this.navigate();
    }

    private navigateSuccess() {
        this._formStateService.continueArgs = arguments;
        this._formStateService.continueFunc = this.navigateSuccess;

        if (this.canDeactivate(null, null, null, null)) {
          this._routerService.navigate(['/', 'admin','client'], { queryParams: { showSuccess: 'true' }});
        }
      }

    private navigate() {  
        this._formStateService.continueArgs = arguments;
        this._formStateService.continueFunc = this.navigate;

        if (this.canDeactivate(null, null, null, null)) {
            this._routerService.navigate(['/', 'admin', 'client']);
        }        
    }

    showContractError(): boolean {
        if (!this.showContracts) {
            this.newHuronContractError = false;
            return false;
      }

      this.newHuronContractError = this.isSubmitted && !(this.activeClient.clientHuronContractModels.length > 0);
        return this.newHuronContractError;
    }

    showOrganizationError() {
        this.organizationError = this.isSubmitted && this.isStuderApplicationSelected() &&
            (!this._organizationService.currentOrganization.legacyLink ||
            this._organizationService.currentOrganization.legacyLink.trim().length < 1 ||
            !this._organizationService.currentOrganization.code ||
            this._organizationService.currentOrganization.code.trim().length < 1 ||
            !this._organizationService.currentOrganization.lemfyMonthStarting ||
            this._organizationService.currentOrganization.lemfyMonthStarting < 1 ||
            this._organizationService.currentOrganization.lemfyMonthStarting > 12);        

        return this.organizationError;
    }

    showIdTokenLifetimeError(app: HhsgSharedApplication): boolean {
        let index = this.getClientApplicationIndex(app);

        if (index === -1 || !this._activeClient.clientApplicationModels[index] || !this._activeClient.clientApplicationModels[index].isActive) {
            return false;
        }

        return this.isSubmitted && !this._activeClient.clientApplicationModels[index].identityTokenLifetime;
    }

    showAccessTokenLifetimeError(app: HhsgSharedApplication): boolean {
        let index = this.getClientApplicationIndex(app);

        if (index === -1 || !this._activeClient.clientApplicationModels[index] || !this._activeClient.clientApplicationModels[index].isActive) {
            return false;
        }

        return this.isSubmitted && !this._activeClient.clientApplicationModels[index].accessTokenLifetime;
    }

    private resetMessages() {
        this.updateSuccess = false;
        this.errorMessages = [];
    }

    disableAddContact(
        addNameInput: HTMLInputElement,
        addPhoneInput: HTMLInputElement,
        addEmailList: HTMLUListElement,
        isNewContact: boolean): boolean {

        let contactName = addNameInput.value;
        let contactPhone = addPhoneInput.value;
        this.newContactValidEmail = true;
        let addEmailInputs = addEmailList.querySelectorAll('input');

        addEmailInputs.forEach(x=>{
            if (!this.isContactEmailValid(x.value)) {
                this.newContactValidEmail = false;                
            }
        });
        
        if (this.isaHuronEmployee) {
            if (!contactName || !this.newContactValidEmail || !this.isContactPhoneValid(contactPhone, isNewContact)) {
                return true;
            }
        }

        return false;
    }

    editContactEmailValidation(addEmailList: HTMLUListElement, rowNumber : Number): void {       
        let editContact = addEmailList.querySelectorAll('input');
        let isValid = true;
        this.editContactErrorMessageShow = false;
        let i : number = 0;

        editContact.forEach(x=>{
            let id = "contactEmail" + rowNumber + "-" + i;           
            if (!this.isContactEmailValid(x.value)) {
                document.getElementById(id).classList.add('ng-invalid');  
                isValid = false;
            }
            else {
                document.getElementById(id).classList.remove('ng-invalid');
            }
            i++
        });        

        if (!isValid) {
            this.editContactErrorMessageShow = true;
        }

    }

    contractsControlEnableValidator(): void  {
        if(this.activeClient.clientHuronContractModels?.length > 0)
        {
            this.formGroup.get('contractNumber').clearValidators();           
        }
        else
        {
            this.formGroup.get('contractNumber').setValidators([Validators.required]);
        }
        this.formGroup.get('contractNumber').updateValueAndValidity();
    }    

    validateContactPhoneNumber(phoneNumberInput : HTMLInputElement)
    {
        let phoneNumber = phoneNumberInput.value;
        if(phoneNumber == '')
        {
            return true;
        }
        return Constants.PhoneRegEx.test(phoneNumber);
        
    }
    
    trimValue(controlName : string): void
    {
        var value =  this.formGroup.get(controlName).value.trim();
        this.formGroup.get(controlName).setValue(value);
    }

    hasValueForStuderApplication(): Boolean
    {
        if(this.isStuderApplicationSelected())
        {        
            if (this._organizationService.currentOrganization?.legacyLink == ''
                || this._organizationService.currentOrganization?.code == ''
                || this._organizationService.currentOrganization?.lemfyMonthStarting == null) {
                return true;
            }
        }
        return false;
    }
    
    onEdited($event): void {
        if ($event) {
            this.markasDirty();
            this.hasValueForStuderApplication();
        }
    } 

    private async loadTimeZones() {        
        (await this._clientAdminService.getTimezones())
        .subscribe(timeZones => {
            this.timeZones = timeZones;
        });
    }

    ngOnDestroy(): void {
        this._formStateService.reset();
        this._unsubscribe$.next();
        this._unsubscribe$.complete();
        this._formChangesSubscription.unsubscribe();
    }
}
